module.exports = __webpack_public_path__ + "static/img/Quicksand-Regular.99d64b5.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Quicksand-Regular.svg
// module id = lfqK
// module chunks = 1